import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

class Hoverable extends Component {
  constructor () {
    super()

    this.state = {
      visible: false
    }
  }

  ALLOWED_MODIFIERS = []

  componentClassNames = () => {
    return bemClasses('hoverable__tooltip', this.ALLOWED_MODIFIERS, this.props)
  }

  onMouseEnter = () => {
    this.setState({ visible: true })
  }

  onMouseLeave = () => {
    this.setState({ visible: false })
  }

  renderTooltip = () => {
    if (this.state.visible) {
      return (
        <span className={this.componentClassNames()}>
          { this.props.text }
        </span>
      )
    }
  }

  render = () => {
    return (
      <span className={'hoverable'} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        { this.props.children }

        { this.renderTooltip() }
      </span>
    )
  }
}

export default Hoverable
